import React, { FC } from 'react';
import { ReactComponent as User } from '../../../assets/MainMenu/User.svg';

export const UserIcon: FC = () => <User />;
